<template>
    <div :class="['popup_basic01', isMenuOpen ? 'open' : 'close']" style="">

        <div class="popup_wrap2">
            <div class="sel_area">
                <div class="sel_control" @click.prevent="closeTopMenu()"><a href="javascript: void(0);">colse</a></div>

                <div class="item_area pdt-10" v-for="topMenu in topMenuList" v-if="topMenu.code === selectedTopMenu">
                    <div class="cur_area">
                        <div class="cur_l">구분</div>
                        <div :class="[selectedTopMenu == 'Air' ? 'cur_r mosquito': 'cur_r']">
                            <a v-for="subMenu in subMenuList[topMenu.code]"
                                :class="[isSubMenuAnchorOn(topMenu.code, subMenu.code) ? 'on' : 'off']"
                                href="javascript: void(0);" @click.prevent="selectSubMenu(topMenu.code, subMenu.code)">
                                <i :class="[subMenu.aClass]"></i>
                                <span class="ic_txt">
                                    {{ subMenu.name }}
                                    <!-- <span v-if="subMenu.code == 'mosquito' ">
                                        ({{mosquitoBasdt}})
                                    </span> -->
                                    <span v-if="typeof subMenu.subMenuMapCnt !== $_TYPE.UNDEF">
                                        ({{ subMenu.subMenuMapCnt }})
                                    </span>
                                </span>
                            </a>
                        </div>
                    </div>
                    <div class="cur_area">
                        <div class="cur_l">시설</div>
                        <div class="cur_r">
                            <ul>
                                <li v-for="(facItem, index) in facilitiesMenu[topMenu.code]" :class="[index > 0 ? 'ml-5' : '']"
                                    v-if="showFacility(facItem)">
                                    <label class="contain">
                                        <input type="checkbox"
                                               :id="'fac-item-' + facItem.id"
                                               :name="'fac_' + topMenu.code"
                                               v-model="facItem.isChecked">
                                        <span class="checkmark"></span>{{ facItem.name }}
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- cur_area//end -->
                </div>

                <div class="sel_option">
                    <p class="sel_icon_col4">
                        <a v-for="topMenu in topMenuList" :key="topMenu.code"
                            :class="[topMenu.code === selectedTopMenu ? 'on' : '']"
                            @click.prevent="selectTopMenu(topMenu.code)"
                            href="javascript: void(0);">
                            <i :class="[topMenu.menuClass]"></i>
                            {{ topMenu.name }}
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { $_TYPE, $_WC, $_DKD, $_NM } from '@/confs/common.const';
import gripUtil from "@/libs/grip.util";
import { mapGetters } from "vuex";
import naverMapShareMixins from '@/stores/naver.map.share.mixin';

export default {
    data() {
        return {
            protocol: window.location.protocol, // http:
        }
    },
    computed: {
        ...mapGetters({
            isMenuOpen: 'getIsMenuOpen',
            topMenuList: 'getTopMenuList',
            subMenuList: 'getSubMenuList',
            facilitiesMenu: 'getFacilitiesMenu',
            selectedTopMenu: 'getSelectedTopMenu',
            selectedSubMenus: 'getSelectedSubMenus',
            selectedFacilitiesMenus: 'getSelectedFacilitiesMenus',
            safetyList: 'getSafetyList',
            accidentList: 'getAccidentList',
            buildingAlarmList: 'getBuildingAlarmList',
            buildingPermitList: 'getBuildingPermitList',
            mosquitoList: 'getMosquitoList',
            mediumMosqList: 'getMediumMosqList',
        }),
        topMenuMap() {
            return gripUtil.toDict(this.topMenuList, 'code');
        },
        mosquitoBasdt() {
            let list = this.mosquitoList;
            let basdtTxt = '';
            if(typeof list !== $_TYPE.UNDEF && list.length > 0) {
                list.sort(function(pre , cur) {
                    return Number(cur.basdtVal) - Number(pre.basdtVal);
                })
                basdtTxt = list[0].basdtVal.substring(0,4);
            }
            return basdtTxt;
        },
        mosquitoCnt() {
            let list = []; ;
            let basdtTxt = this.mosquitoBasdt;
            let cnt = 0;
            if(typeof this.mosquitoList !== $_TYPE.UNDEF && this.mosquitoList.length > 0) {
                if(typeof basdtTxt !== $_TYPE.UNDEF &&  basdtTxt !== '') {
                    let filterDate = basdtTxt+'0101';
                    // console.log(filterDate);
                    list = this.mosquitoList.filter((data)=> {
                        return Number(data.basdtVal) >= Number(filterDate);
                    })
                    cnt = list.length;
                }
            }
            return cnt;
        },
    },
    created() {
        if(typeof this.$route.query['mCode'] === $_TYPE.UNDEF){
            this.$eventBus.$once("DrawRegionNaverMap::completed-draw-region", geoJsonDrawing => {
                // this.selectTopMenu('Safety', false);
                this.selectTopMenu('Realcity', false);
            });
        } else {
            let sCode = '';
            if(typeof this.$route.query['sCode'] !== $_TYPE.UNDEF){
                sCode = this.$route.query['sCode'];
            }
            this.selectTopMenu(this.$route.query['mCode'], false, sCode);
        }
    },
    watch: {
        safetyList: {
            immediate: true,
            handler: function (newVal, oldVal) {
                this.setSafetyMenuCnt();
            }
        },
        accidentList: {
            immediate: true,
            handler: function (newVal, oldVal) {
                this.setAccidentMenuCnt();
            }
        },
        mosquitoList: {
            immediate: true,
            handler: function() {
                this.setAirMenuCnt();
            }
        },
        buildingAlarmList: {
            immediate: true,
            handler: function (newVal, oldVal) {
                this.setBuildingAlarmCnt();
            }
        },
        buildingPermitList: {
            immediate: true,
            handler: function (newVal, oldVal) {
                this.setBuildingAlarmCnt();
            }
        },
        selectedTopMenu: {
            immediate: false,
            handler(newVal, oldVal) {
                if(typeof this.recognizer !== 'undefined') {
                    this.recognizer.hide();
                    this.$store.dispatch('SET_SELECTED_SAFETY_CATE', 'all');
                }
            }
        },
    },
    methods: {
        showFacility(facItem){
            if(this.protocol.indexOf('https') > -1 && facItem.id === 'uticCctv'){
                return false;
            }
            return true;
        },
        closeTopMenu(){
            this.$store.dispatch("SET_IS_MENU_OPEN", false);
        },
        selectTopMenu(topMenuCode, isOpen, subMenuCode){
            // 다중밀집지역 추가로, 다른 메뉴 선택 시 초기 zoom으로 돌아가기
            let lat = $_WC.responsiveScale === 3 ? $_WC.localGovLatitude :  $_WC.localGovLatitude;
            let lng = $_WC.responsiveScale === 3 ? 127.033313 : $_WC.localGovLongitude;
            let zoom = $_NM.ZOOM_LEVEL;
            this.map.setZoom(zoom);
    		this.map.setCenter(new naver.maps.LatLng(37.495408, 127.060313));
            
            if(typeof isOpen === $_TYPE.UNDEF) {
                isOpen = true;
            }
            // 톱메뉴 컨트롤
            if(topMenuCode === this.selectedTopMenu) {
                this.$store.dispatch("SET_IS_MENU_OPEN", !this.isMenuOpen);
            } else {
                this.$store.dispatch('SET_SEOUL_MAP_MENU', 'pm10'); // 서울지도 메뉴 초기화

                if(!this.isMenuOpen && isOpen) {
                    this.$store.dispatch("SET_IS_MENU_OPEN", true);
                }
                this.disableAllMarker();
                if(typeof this.geoJsonDrawing !== $_TYPE.UNDEF){
                    this.geoJsonDrawing.setOptionAll("fillColor", "#b0b0b0");
                }
                this.$store.dispatch("SET_SELECTED_TOP_MENU", topMenuCode);

                // 서브메뉴 초기화
                let selectedSubMenus = [];
                if(topMenuCode !== '') {
                    if(typeof subMenuCode !== $_TYPE.UNDEF && subMenuCode !== '') {
                        // 서브메뉴 파라미터 존재여부
                        selectedSubMenus.push(subMenuCode);
                    } else {
                        this.subMenuList[topMenuCode].forEach((subMenu)=>{
                            if(subMenu.defaultChecked) {
                                selectedSubMenus.push(subMenu.code);
                            }
                        });
                    }
                }
                this.$store.dispatch("SET_SELECTED_SUB_MENUS", selectedSubMenus);

                // 시설선택 초기화
                for(let facType in this.facilitiesMenu) {
                    this.facilitiesMenu[facType].forEach((facItem)=>{
                        if(this.selectedTopMenu === facType && facItem.defaultChecked) {
                            facItem.isChecked = true;
                        } else {
                            facItem.isChecked = false;
                        }
                    });
                }
            }
        },
        isSubMenuAnchorOn(topMenuCode, subMenuCode) {
            return (this.selectedTopMenu === topMenuCode && this.selectedSubMenus.includes(subMenuCode));
        },
        selectSubMenu(topMenuCode, subMenuCode) {
            let topMenu = this.topMenuMap[topMenuCode];
            let selectedSubMenus = [];
            if(topMenu.multiSub) {
                if(this.selectedSubMenus.includes(subMenuCode)) {
                    selectedSubMenus = this.selectedSubMenus.filter(function(selectedSubMenuCode) {
                        return selectedSubMenuCode !== subMenuCode;
                    });
                } else {
                    selectedSubMenus = this.selectedSubMenus.concat([subMenuCode]);
                }
            } else {
                selectedSubMenus.push(subMenuCode);
            }
            if(topMenuCode === 'Air') {
                if(subMenuCode !== 'decibel') {
                    // this.selectSeoulMapMenu(subMenuCode);
                }
            }

            // 하위메뉴 선택 시 도시데이터 팝업 표출
            if(topMenuCode == 'Realcity') {
                this.$eventBus.$emit('SeoulmapMapCtrl::show-seoulmap-pop');
            }

            // 건설마커 선택 수정
            if(subMenuCode === '1152') {
                this.disableMarker('1152');
            }
            //지도 마커 초기화
            // this.disableAllMarker();

            this.$store.dispatch("SET_SELECTED_SUB_MENUS", selectedSubMenus);
        },
        setSafetyMenuCnt(){
            let safetyTypeMap = gripUtil.toMap(this.safetyList, 'safetyCategoryCd');
            this.subMenuList['Safety'].forEach((menu)=>{
                menu.subMenuMapCnt = 0;
                if(safetyTypeMap.hasOwnProperty(menu.code)) {
                    if(Object.keys(safetyTypeMap).length > 0){
                        menu.subMenuMapCnt = safetyTypeMap[menu.code].length;
                    }
                }
            });
        },
        setAccidentMenuCnt(){
            let accidentTypeMap = gripUtil.toMap(this.accidentList, 'val2');
            this.subMenuList['Accident'].forEach((menu)=>{
                menu.subMenuMapCnt = 0;
                if(accidentTypeMap.hasOwnProperty(menu.code)) {
                    if(Object.keys(accidentTypeMap).length > 0){
                        menu.subMenuMapCnt = accidentTypeMap[menu.code].length;
                    }
                }
            });
        },
        setAirMenuCnt(){
            this.subMenuList['Air'].forEach((menu)=> {
                if(menu.code === 'mosquito') {
                    menu.subMenuMapCnt = 0;
                    if(typeof this.mosquitoList !== $_TYPE.UNDEF) {
                        let cnt = this.mosquitoCnt;
                        menu.subMenuMapCnt = cnt;
                    }
                }
            });
        },
        setBuildingAlarmCnt(){
            let menuMap = gripUtil.toDict(this.subMenuList['Accident'], 'code');
            let menu = menuMap[$_DKD.BUILDING_ALARM];
            menu.subMenuMapCnt = this.buildingAlarmList.length + this.buildingPermitList.length;
        },
    },
    mixins: [naverMapShareMixins],
};
</script>
